import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "preloader" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "preloader" }, [
      _createElementVNode("div", { class: "waviy" }, [
        _createElementVNode("span", null, "N"),
        _createElementVNode("span", null, "Y"),
        _createElementVNode("span", null, "L"),
        _createElementVNode("span", null, "O")
      ])
    ], -1)
  ]))]))
}